import { useStores } from "../../../../use-stores";
import { EmployeeRoles } from "../../../../../../models/Employees/EmployeeRoles";

export type DailyTasksFieldPermissions = {
  canViewDispatchDate: boolean;
  canViewCostPrice: boolean;
};

/** Dispatch date + cost price (printing cost / CP). Selling price is not on this dashboard. */
export function useDailyTasksFieldPermissions(): DailyTasksFieldPermissions {
  const { userStore } = useStores();
  return {
    canViewDispatchDate: userStore.hasPermission(
      EmployeeRoles.VIEW_DISPATCH_DATE,
    ),
    canViewCostPrice: userStore.hasPermission(
      [EmployeeRoles.VIEW_COST_PRICE, EmployeeRoles.CHANGE_COST_PRICE],
      true,
    ),
  };
}
